import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import moment from "moment";

import { getUser } from "../../store/reducers/authSlice";
import { GradientTypo } from "../header/Header";
import {useIsMobile} from "../../hooks/responsive";
import { ReactComponent as UserShape } from "../../resources/images/svg/home/userShape.svg";

import { ReactComponent as EnlargeYourKnowledge } from "../../resources/images/svg/home/enlargeYourKnowledge.svg";
import { ReactComponent as Level1Icon } from "../../resources/images/svg/home/profile/level1.svg";
import { ReactComponent as Level2Icon } from "../../resources/images/svg/home/profile/level2.svg";
import { ReactComponent as Level3Icon } from "../../resources/images/svg/home/profile/level3.svg";
import { ReactComponent as LevelOffIcon } from "../../resources/images/svg/home/profile/levelOff.svg";

const Level = ({ level }) => {
  return (
    <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          marginTop: 2,
          gap: 1,
        }}
      >
        <Level1Icon />
        {level >= 2 ? <Level2Icon /> : <LevelOffIcon />}
        {level >= 3 ? <Level3Icon /> : <LevelOffIcon />}
      </Box>
  );
};

const Header = ({proInfo, handleScrollProfile}) => {
  const isMobile = useIsMobile();
  const user = useSelector(getUser);
  const theme = useTheme();

    const [currentCertificate, setCurrentCertificate] = React.useState({certificate:'pending', candidateDate:'0000-00-00'});
  
    React.useEffect(() => {
      if (proInfo) {
        setCurrentCertificate({candidateDate: proInfo?.candidateDate, certificate: proInfo?.certificate ?? 'pending'});
      }
    }, [proInfo]);

  const userInitials = React.useMemo(() => {
    return user ? `${user?.prenom?.charAt(0).toUpperCase()}${user?.nom?.charAt(0).toUpperCase()}`:'';
  }, [user]);
  
  const userName = React.useMemo(() => {
    const firstName =
      user?.prenom.charAt(0).toUpperCase() + user?.prenom.substring(1);
    const lastName = user?.nom.charAt(0).toUpperCase() + user?.nom.substring(1);
    return `${firstName ?? "A"} ${lastName ?? "A"}`;
  }, [user]);
  
  const userNiveau = React.useMemo(() => {
    if(parseInt(user?.niveau) > 0) {
      return parseInt(user?.niveau);
    }
    return 0;
  }, [user]);
  
    const levelColor = React.useMemo(() => {
      if (userNiveau <= 1 || !user) return "#0596A1";
      if (userNiveau === 2) return "#3971F6";
      if (userNiveau >= 3) return "#9A45F4";
    }, [userNiveau]);

  return (
    <>
      <Box
        sx={{
          color: "white",
          fontWeight: 900,
          fontSize: 18,
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
        }}>

        <Box
          sx={{
            justifyContent: "center",
            display: "inherit",
            position: "relative",
          }}
        >
          <UserShape  style={{ height: 200, width: 200 }}/>
          <Typography
            variant={"h2"}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "white",
              padding: 0,
              margin: 0,
            }}
          >
            {userInitials || ''}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: 26,
              fontWeight: 900,
              marginTop: isMobile ? "-25px" : "25px",
              textAlign: isMobile ? "center" : "none"
            }}
          >
            
          <span
            style={{
              color: levelColor,
            }}
          >{`Bienvenue `}</span>
          {` ${userName || ''}`}  
          <span
            style={{
              color: levelColor,
            }}
          >{` dans notre réseau de professionnels de l'accompagnement`}</span>
          </Typography>
          <Typography
            sx={{
              fontSize: 18,
              color: "white",
              fontWeight: 900,
            }}
          >
            {userNiveau === 3 && (<>{`Bravo ! Vous êtes désormais praticien référencé.`}</>)}
            {userNiveau === 1 && (<>Signez notre Charte éthique pour devenir praticien engagé <a onClick={handleScrollProfile} style={{textDecoration:"underline", cursor: "pointer"}}>dès maintenant</a>.</>)}
            {userNiveau === 2 && (
              <>{currentCertificate?.certificate === "inProgress" ?
                  `Votre demande de labellisation est en cours d’étude.` :
                  currentCertificate?.certificate === "rejected"  && moment(currentCertificate?.candidateDate).diff(moment(), 'days') >= 0 ?
                    `Continuez à faire mûrir votre pratique avant de candidater à nouveau au label.` : 
                        currentCertificate?.certificate === "notReady" ?
                  (<>Participez à nos événements puis candidatez au label <a onClick={handleScrollProfile} style={{textDecoration:"underline", cursor: "pointer"}}>le moment venu</a>.</>) :
                        (<>Candidatez au label Inexploré et rejoignez notre annuaire <a onClick={handleScrollProfile} style={{textDecoration:"underline", cursor: "pointer"}}>dès maintenant</a>.</>)
                  }
                </>)}
          </Typography>
          <Level level={userNiveau ?? 1} />
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          mt: 3,
          mb: 2,
          width: "100%"
        }}
      >
        <EnlargeYourKnowledge
          width={"62px"}
          height={"62px"}
          style={{
            marginRight: "20px",
          }}
        />
        <Typography
          variant="h2"
          sx={{
            fontWeight: 500,
            margin: 0,
            textAlign: "center",
            color: "white",
          }}
        >
          Élargissez vos connaissances
        </Typography>
        <GradientTypo
          variant={"h2"}
          background={theme.palette.linearPro}
          sx={{
            fontFamily: "YesevaOne",
            textTransform: "lowercase",
            textAlign: "center",
            margin: 0,
            fontWeight: 500,
            "&:first-letter": {
              textTransform: "lowercase !important",
            },
          }}
        >
          &nbsp;{`multidimensionnelles`}
        </GradientTypo>
      </Box>
    </>
  );
};

export default Header;
